import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, collection, getDocs, doc, setDoc } from '../firebase';
import { Helmet } from 'react-helmet';
import { createTranslator, useLanguage } from '../i18n/LanguageContext';
import { leagueTranslations } from '../i18n/translations';

const LeagueList = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = createTranslator(language, leagueTranslations);
  const [leagues, setLeagues] = useState([]);
  const [loadingLeagues, setLoadingLeagues] = useState(false);
  

  const [upcomingLeagues, setUpcomingLeagues] = useState([]);
  const [pastLeagues, setPastLeagues] = useState([]);
  const [teamsCounts, setTeamsCounts] = useState({});
  const [showPopup, setShowPopup] = useState(true); 
  // Formatage des dates en français avec l'année
  const formatFrenchDate = (date) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Intl.DateTimeFormat(language, options).format(new Date(date));
  };

  // Formatage de la plage de dates
  const formatDateRange = (dateRange) => {
    if (!dateRange || dateRange.length !== 2) return t('dateUndefined');
    const [startDate, endDate] = dateRange;
    return t('fromTo', { start: formatFrenchDate(startDate), end: formatFrenchDate(endDate) });
  };

  useEffect(() => {
    const loadLeagues = async () => {
      try {
        setLoadingLeagues(true);
  
        const snapshot = await getDocs(collection(db, 'league_registrations'));
  
        const data = snapshot.docs
          .map((docSnap) => {
            const data = docSnap.data();
  
            return {
              ...data,
              _docId: docSnap.id,
              id: Number(data.id ?? docSnap.id),
              dateRange: data.dateRange || [
                data.startDate || '',
                data.endDate || data.startDate || '',
              ],
            };
          })
          .filter((league) => league.archived !== true && league.visible !== false)
          .sort((a, b) => {
            const dateA = a.dateRange?.[0] ? new Date(a.dateRange[0]).getTime() : 0;
            const dateB = b.dateRange?.[0] ? new Date(b.dateRange[0]).getTime() : 0;
  
            if (dateA !== dateB) return dateA - dateB;
  
            return Number(a.id || 0) - Number(b.id || 0);
          });
  
        setLeagues(data);
      } catch (error) {
        console.error('Erreur chargement des ligues:', error);
      } finally {
        setLoadingLeagues(false);
      }
    };
  
    loadLeagues();
  }, []);

  useEffect(() => {
    const loadLeagues = async () => {
      try {
        setLoadingLeagues(true);
  
        const snapshot = await getDocs(collection(db, 'league_registrations'));
  
        const data = snapshot.docs
          .map((docSnap) => {
            const data = docSnap.data();
  
            return {
              ...data,
              _docId: docSnap.id,
              id: Number(data.id ?? docSnap.id),
              dateRange: data.dateRange || [
                data.startDate || '',
                data.endDate || data.startDate || '',
              ],
            };
          })
          .filter((league) => league.archived !== true && league.visible !== false)
          .sort((a, b) => {
            const dateA = a.dateRange?.[0] ? new Date(a.dateRange[0]).getTime() : 0;
            const dateB = b.dateRange?.[0] ? new Date(b.dateRange[0]).getTime() : 0;
  
            if (dateA !== dateB) return dateA - dateB;
  
            return Number(a.id || 0) - Number(b.id || 0);
          });
  
        setLeagues(data);
      } catch (error) {
        console.error('Erreur chargement des ligues:', error);
      } finally {
        setLoadingLeagues(false);
      }
    };
  
    loadLeagues();
  }, []);
  useEffect(() => {
    const today = new Date();

    const sortedLeagues = leagues.reduce(
      (acc, league) => {
        let isUpcoming = false;

        if (league.date) {
          const leagueDate = new Date(league.date);
          isUpcoming = leagueDate >= today;
        } else if (league.dateRange) {
          const endDate = new Date(league.dateRange[1]);
          isUpcoming = endDate >= today;
        }

        if (isUpcoming) {
          acc.upcoming.push(league);
        } else {
          acc.past.push(league);
        }

        return acc;
      },
      { upcoming: [], past: [] }
    );

    setUpcomingLeagues(sortedLeagues.upcoming);
    setPastLeagues(sortedLeagues.past);
  }, [leagues]);

  useEffect(() => {
    const fetchTeamsCounts = async () => {
      try {
        const res = await fetch("https://us-central1-mendyx-adafe.cloudfunctions.net/getAllLeagueParticipantsCounts");
  
        const data = await res.json();
  
        if (res.ok && data.counts) {
          const parsedCounts = {};
          for (const id in data.counts) {
            parsedCounts[parseInt(id)] = data.counts[id];
          }
          setTeamsCounts(parsedCounts);
        } else {
          console.error("Erreur serveur :", data.error || "Structure inattendue");
        }
      } catch (err) {
        console.error("Erreur de requête :", err);
      }
    };
  
    fetchTeamsCounts();
  }, []);
  
  

  const handleRegisterClick = (leagueId) => {
    navigate(`/register-league/${leagueId}`);
  };

  const handleViewCalendarClick = (leagueId) => {
    navigate(`/league/${leagueId}/calendarleague`);
  };

  const handleEncodeScoreClick = (leagueId) => {
    navigate(`/league/${leagueId}/encodescoresleague`);
  };

  const renderLeagueCard = (league) => {
    const currentTeamsCount = teamsCounts[league.id] || 0;
    const isFull = currentTeamsCount === league.players; // Vérifie si la ligue est complète

    return (
        <div key={league.id} className="relative p-8 bg-white shadow-lg rounded-3xl border border-gray-200 transform transition hover:scale-105 duration-300 ease-in-out">
            {isFull && (
                <div className="absolute top-0 right-0 bg-red-600 text-white px-4 py-1 rounded-bl-2xl text-sm font-bold">
                    COMPLET
                </div>
            )}

          {league.picture && (
    <div className="flex items-center justify-between mb-4">
        <h3 className="text-2xl font-semibold text-[#800020] break-words">
            {league.name}
        </h3>
        <div className="w-16 h-16 flex items-center justify-center">
            <img
                src={league.picture}
                alt={`${league.name} logo`}
                className="max-w-full max-h-full rounded-full border-2 border-gray-200 shadow object-contain"
            />
        </div>
    </div>
)}


            <p className="text-gray-600 mb-1">{t('teams')} : {league.players}</p>
            <p className="text-gray-600 mb-1">{t('location')} : <strong>{league.location}</strong></p>
            <p className="text-gray-600 mb-1">{t('date')} : {formatDateRange(league.dateRange)}</p>
            <p className="text-gray-600 mb-1">{t('schedule', { day: league.day, time: league.time })}</p>
            <p className="text-gray-600 mb-1">{t('registeredTeams')} : {currentTeamsCount}</p>
            <p className="text-gray-600 mb-1">
            {league.eloMin && league.eloMax && (
  <p className="text-gray-600 mb-1">
    {t('category')} : {league.eloMin} - {league.eloMax} ELO ({t('perTeam')})
  </p>
)}


            </p>

            <div className="mt-4 flex flex-col gap-4 md:flex-row md:gap-4">
    <button
        onClick={() => handleRegisterClick(league.id)}
        className={`w-full md:w-auto px-4 py-2 text-sm md:text-base rounded-full transition duration-300 ${
            isFull ? "bg-gray-400 cursor-not-allowed" : "bg-[#800020] text-white hover:bg-white hover:text-[#800020] border hover:border-[#800020]"
        }`}
        disabled={isFull}
    >
        {isFull ? t('full') : t('register')}
    </button>

    <button
        onClick={() => handleViewCalendarClick(league.id)}
        className="w-full md:w-auto px-4 py-2 text-sm md:text-base bg-[#800020] text-white rounded-full hover:bg-white hover:text-[#800020] border hover:border-[#800020] transition duration-300"
    >
        {t('calendar')}
    </button>

    <button
        onClick={() => handleEncodeScoreClick(league.id)}
        className="w-full md:w-auto px-4 py-2 text-sm md:text-base bg-[#800020] text-white rounded-full hover:bg-white hover:text-[#800020] border hover:border-[#800020] transition duration-300"
    >
        {t('enterScores')}
    </button>

    {/* Nouveau bouton pour rediriger vers le règlement de la ligue */}
    <button
        onClick={() => window.location.href = '/reglementleague'}
        className="w-full md:w-auto px-4 py-2 text-sm md:text-base bg-[#800020] text-white rounded-full hover:bg-white hover:text-[#800020] border hover:border-[#800020] transition duration-300"
    >
        {t('rules')}
    </button>
</div>

        </div>
    );
};

  return (
  
    <>


 {/* Pop-up */}
 {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full relative">
            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl"
            >
              &times;
            </button>
            <h2 className="text-2xl font-bold text-[#800020] mb-4 text-center">{t('infoTitle')}</h2>
            <div className="overflow-y-auto max-h-96">
              <p className="text-gray-700 mb-4 text-center">
                {t('infoIntro')}
              </p>
              <p className="text-gray-700 mb-4">
                {t('infoPrinciple')}
              </p>
              <p className="text-gray-700 mb-4">
                {t('infoChoose')}
              </p>
              <p className="text-gray-700 mb-4">
                {t('infoThree')}
              </p>
              <p className="text-gray-700 mb-4">
                Exemple : tous les samedis de 15h à 16h30 au club de Sombreffe
              </p>
              <p className="text-gray-700 mb-4">
                🗓 Exemple concret :
              </p>
              <p className="text-gray-700 mb-4">
                Vous vous inscrivez à la ligue “Sombreffe – Samedi 15h”
              </p>
              <p className="text-gray-700 mb-4">
                → Vous jouerez aux dates suivantes :
              </p>
              <p className="text-gray-700 mb-4">
                Samedi 6 juillet de 15h à 16h30
              </p>
              <p className="text-gray-700 mb-4">
                Samedi 13 juillet de 15h à 16h30
              </p>
              <p className="text-gray-700 mb-4">
                Samedi 20 juillet de 15h à 16h30
              </p>
              <p className="text-gray-700 mb-4">
                🎯 Ce que vous recevez :
              </p>
              <p className="text-gray-700 mb-4">
                {t('infoSchedule')}
              </p>
              <p className="text-gray-700 mb-4">
                Les noms des équipes adverses
              </p>
              <p className="text-gray-700 mb-4">
                Un accès pour encoder vos scores à la fin de chaque rencontre
              </p>
              <p className="text-gray-700 mb-4">
                {t('infoRanking')}
              </p>
              <p className="text-gray-700 mb-4">
                Les scores s’enregistrent après chaque match
              </p>
              <p className="text-gray-700 mb-4">
                Le classement se met à jour en temps réel grâce à notre système de points
              </p>
              <p className="text-gray-700 mb-4">
                {t('infoWhy')}
              </p>
              <p className="text-gray-700 mb-4">
                Pour vivre 3 matchs équilibrés, longs et motivants
              </p>
              <p className="text-gray-700 mb-4">
                Pour rencontrer des adversaires différents à chaque fois
              </p>
              <p className="text-gray-700 mb-4">
                Et pour les meilleurs : une récompense de 2x 25€ à gagner pour l’équipe vainqueur !
              </p>
            </div>
            <div className="mt-4 flex justify-center">
              <button
                onClick={() => setShowPopup(false)}
                className="px-4 py-2 bg-[#800020] text-white rounded-full hover:bg-white hover:text-[#800020] border hover:border-[#800020] transition duration-300"
              >
                {t('close')}
              </button>
            </div>
          </div>
        </div>
      )}


      {/* Helmet for SEO */}
      <Helmet>
        <title>{t('pageTitle')}</title>
        <meta name="description" content="Découvrez nos ligues de padel en Belgique. Inscrivez-vous et participez aux ligues organisées par Padel Mendyx." />
        <meta name="keywords" content="ligues de padel, compétition padel Belgique, Padel Mendyx, Namur, Charleroi, Brabant Wallon" />
        <meta property="og:title" content="Ligues de Padel en Belgique | Padel Mendyx" />
        <meta property="og:description" content="Rejoignez les ligues de padel en Belgique. Découvrez les ligues organisées par Padel Mendyx." />
        <meta property="og:image" content="/BDL.jfif" />
        <meta property="og:url" content="https://padelmedyx.com/leaguelist" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://padelmedyx.com/leaguelist" />
        
        <script type="application/ld+json">
          {JSON.stringify(
            leagues.map(league => ({
              "@context": "https://schema.org",
              "@type": "Event",
              "name": league.name,
              "startDate": league.dateRange[0],
              "endDate": league.dateRange[1],
              "location": {
                "@type": "Place",
                "name": league.location,
              },
              "description": `Participez à ${league.name}. Catégorie ${league.category}.`,
            }))
          )}
        </script>
      </Helmet>
    
    <section className="container mx-auto my-24 px-4">
      <div>
        <h2 className="text-3xl font-semibold text-[#800020] mb-12 text-center">{t('upcoming')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24">
        {loadingLeagues ? (
  <p className="text-center text-gray-500 md:col-span-2">
    {t('loading')}
  </p>
) : upcomingLeagues.length > 0 ? (
  upcomingLeagues.map(renderLeagueCard)
) : (
  <p className="text-center text-gray-500 md:col-span-2">
    {t('noUpcoming')}
  </p>
)}
        </div>
      </div>

      <div className="mt-16">
        <h2 className="text-3xl font-semibold text-[#800020] mb-12 text-center">{t('past')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24">
        {loadingLeagues ? (
  <p className="text-center text-gray-500 md:col-span-2">
    {t('loading')}
  </p>
) : pastLeagues.length > 0 ? (
  pastLeagues.map(renderLeagueCard)
) : (
  <p className="text-center text-gray-500 md:col-span-2">
    {t('noPast')}
  </p>
)}
        </div>
      </div>
    </section>
    </>
  );
};

export default LeagueList;
